import { AnimatePresence } from "framer-motion";
import { JSX } from "react";
import { useMatch } from "react-router-dom";
import { Settings } from "./Settings";
import { Profile } from "./Profile";
import { Contact } from "./Contact";
import { Notification } from "./Notification";
import { Dating } from "./Dating";
import { Billing } from "./Billing";

const SUB_PAGES: Record<string, () => JSX.Element> = {
  profile: Profile,
  contact: Contact,
  notification: Notification,
  dating: Dating,
  billing: Billing,
};

export function SettingsOverlay() {
  const inSettings = useMatch("/settings/*") !== null;
  const subMatch = useMatch("/settings/:section");
  const section = subMatch?.params.section;
  const SubPage = section ? SUB_PAGES[section] : undefined;

  return (
    <>
      <AnimatePresence>
        {inSettings && <Settings key="settings-index" />}
      </AnimatePresence>
      <AnimatePresence>
        {SubPage && <SubPage key={`settings-${section}`} />}
      </AnimatePresence>
    </>
  );
}
